import { LogOut, TriangleAlert } from "lucide-react";

interface ImpersonationBannerProps {
  userName?: string;
  onLeave: () => void;
}

export function ImpersonationBanner({
  userName,
  onLeave,
}: ImpersonationBannerProps) {
  return (
    <div className="w-full bg-amber-600 text-white text-sm font-medium h-14 px-6 flex items-center justify-between z-50 transition-all duration-180 ease-out">
      <span className="inline-flex items-center gap-2">
        <TriangleAlert className="h-4 w-4" />
        Modo Observador - Você está logado como: <strong>{userName}</strong>
      </span>
      <button
        onClick={onLeave}
        aria-label="Voltar ao Super Admin"
        className="flex items-center justify-center gap-1 bg-muted/45 hover:bg-muted/65 h-11 px-4 rounded-xl transition-all duration-180 ease-out cursor-pointer"
      >
        <LogOut className="w-4 h-4" /> Voltar ao Super Admin
      </button>
    </div>
  );
}
